import {ReactChild} from "react"

export function PageTabInDetailPage({children}: ChildrenProps) {
    return (
        <PageTabContainer>
            <PageTabBar>
                {children}
            </PageTabBar>
        </PageTabContainer>
    )
}

type ChildrenProps = {
    children: ReactChild | ReactChild[]
}

function PageTabContainer({children}: ChildrenProps) {
    return (
        <div className="gray-box">
            {children}
        </div>
    )
}

function PageTabBar({children}: ChildrenProps) {
    return (
        <ul className="tab-gray is-size-85">
            {children}
        </ul>
    )
}

type PageTabProps = {
    active?: boolean
    onClick?: () => void
    title: string
    iconClass?: string
}

export function PageTabItemInDetailPage({active, onClick, title, iconClass}: PageTabProps) {
    return (
        <li>
            <a className={active ? "active" : ""}
               onClick={onClick}>
                <span className="icon is-small">
                    <i className={`fa-solid ${iconClass ? iconClass : ""}`}></i>
                </span>
                <span> {title}</span>
            </a>
        </li>
    )
}